<template>
  <div class="group-list">
    <router-link to="/view/create">
      <el-button type="primary" class="m-2">添加景点</el-button>
    </router-link>
    <div>当前城市：{{userInfo.cur_city.city_name}}</div>
    <el-table :data="list" v-loading="isLoading">
      <el-table-column
        prop="img"
        label="图片"
      >
        <template slot-scope="scope"><img :src="scope.row.img|ossurl" alt=""
            :style="{
              width: '80px',
              height: 'auto',
              margin: '10px 0 0 0'
            }"
          ></template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="景点名"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
      >
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.status===1">待审核</el-tag>
          <el-tag type="success" v-if="scope.row.status===2">上线</el-tag>
          <el-tag type="warning" v-if="scope.row.status===3">下线</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作"
      >
        <template slot-scope="scope">
          <router-link :to="'/view/'+scope.row.id">
          <el-button type="text">编辑</el-button>
        </router-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getViewList } from '@/api/shop'
import store from '@/store'

export default {
  name: 'ViewList',
  data () {
    return {
      isLoading: false,
      list: [],
      userInfo: {}
    }
  },
  created () {
    this.userInfo = store.state.userInfo
    this.getList()
  },
  methods: {
    async getList (page = 1, size = 10) {
      this.isLoading = true
      const { shops } = await getViewList(6)
      this.list = shops
      this.isLoading = false
    }
  }
}
</script>




// WEBPACK FOOTER //
// view-list.vue?502f0a3a